function addParticipant() {
    var template = document.querySelector('[data-participant-template]');
    if (template.length < 1) {
        return;
    }
    var clone = template.innerHTML;
    var participants = document.querySelectorAll('.participants .participant');
    if (participants.length < 1) {
        return;
    }
    var lastParticipant = participants[participants.length - 1];
    if (lastParticipant.length < 1) {
        return;
    }
    lastParticipant.insertAdjacentHTML('afterend', clone.replace(/\[0\]/g, '[' + participants.length + ']').replaceAll(/-0-/g, '-' + participants.length + '-'));
}

function removeParticipant(element) {
    element.parentNode.parentNode.parentNode.removeChild(element.parentNode.parentNode);
}

function replaceTrustedPropertiesToken(data) {
    var element = document.querySelector('[name="tx_eventmanagement_event_list[__trustedProperties]"]');
    element.setAttribute('value', data.trustedPropertiesToken);
}


/**
 * Gets all elements with class 'field' from form,
 * if it finds an input from billingContact and participant with the data-property as id,
 * it fills the billingContact value with the participant value.
 *
 * @param participantForm DOM Object
 * @param index int index of participant
 */
 function fillBillingContactWithParticipant(participantForm) {
    var fields = participantForm.querySelectorAll('.field');
    fields.forEach(function (field) {
        var billingContactInput = document.getElementById('billingContact-0-' + field.dataset.property),
            participantInput = field.querySelector('.field-input');
        if (billingContactInput && participantInput) {
            billingContactInput.value = participantInput.value;
        }
    });
}


function isParticipantAddable(element) {
    var url = element.getAttribute('href');
    var currentParticipantCount = document.querySelectorAll('.participant').length;
    url = url + '?currentCount=' + currentParticipantCount
    fetch(url).then(function(response) {
        return response.json()
    })
    .then(function(data) {
        if (data.isParticipantAddable) {
            addParticipant();
            replaceTrustedPropertiesToken(data);
        }
    });
}

function initEventListener() {
    document.addEventListener('click', function(event) {
        if (event.target.hasAttribute('data-add-participant')) {
            event.preventDefault();
            isParticipantAddable(event.target);
        }
        if (event.target.hasAttribute('data-remove-participant')) {
            event.preventDefault();
            removeParticipant(event.target);
        }
        if (event.target.hasAttribute('data-participant-to-billing-contact')) {
            event.preventDefault();
            fillBillingContactWithParticipant(event.target.parentNode.parentNode);
            document.dispatchEvent(new Event('eventmanagement:billingcontact:fill'));
        }
    });
}


document.addEventListener('DOMContentLoaded', function() {
    initEventListener();
});